import { get } from '../request';

export async function fetchZestimate(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear = 2017 },
) {
  const url = `${appraisalService}/appraisal/zillow/zestimate/${propertyId}/${pYear}/0/0`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchZProperty(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear = 2017 },
) {
  const url = `${appraisalService}/appraisal/zillow/zpropertydetails/${propertyId}/${pYear}/0/0`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchZComps(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear = 2017 },
) {
  const url = `${appraisalService}/appraisal/zillow/zcomps/${propertyId}/${pYear}/0/0`;
  const { body } = await get(authenticationToken, url);
  return body;
}
